import React, { useState } from 'react';
import { Button, Card, Form } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import PageHeader, { AlertMessage } from '../../components/PageHeader';
import AdminNav from '../../components/AdminNav';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { adminApi } from '../../services/api';

export default function AdminAccount() {
  const { username, logout } = useAdminAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (newPassword !== confirm) {
      setError('New passwords do not match');
      return;
    }
    if (newPassword.length < 8) {
      setError('New password must be at least 8 characters');
      return;
    }
    setLoading(true);
    try {
      await adminApi.rotatePassword(currentPassword, newPassword);
      setSuccess('Password updated. Sign in again with your new password.');
      setCurrentPassword('');
      setNewPassword('');
      setConfirm('');
      // Old JWT is revoked server-side; clear admin session.
      setTimeout(() => logout(), 800);
    } catch (err) {
      setError(err.message || 'Could not update password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageHeader
        title="Account"
        subtitle={`Platform admin${username ? ` · ${username}` : ''}`}
      >
        <Button variant="outline-danger" size="sm" onClick={logout}>
          <FontAwesomeIcon icon={faSignOutAlt} className="me-1" />
          Sign out
        </Button>
      </PageHeader>

      <AdminNav />

      <AlertMessage variant="danger" message={error} onClose={() => setError('')} />
      <AlertMessage variant="success" message={success} onClose={() => setSuccess('')} />

      <Card border="light" className="shadow-sm" style={{ maxWidth: 480 }}>
        <Card.Body>
          <h6 className="mb-3">Change password</h6>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Current password</Form.Label>
              <Form.Control
                required
                type="password"
                autoComplete="current-password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>New password</Form.Label>
              <Form.Control
                required
                type="password"
                minLength={8}
                autoComplete="new-password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label>Confirm new password</Form.Label>
              <Form.Control
                required
                type="password"
                minLength={8}
                autoComplete="new-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
              />
            </Form.Group>
            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? 'Updating…' : 'Update password'}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
}
